<template>
  <Modal
    :value="open"
    :onClose="close"
    :close="false"
    title="Movimentação de caixa (Suprimento / Sangria)"
  >
    <b-row>
      <b-col md="6" lg="6" sm="12">
        <Money
          ref="valorPagamento"
          id="valorPagamento"
          :options="quantity"
          label="Valor:"
          labelBold
          inputClass="form-control input"
          v-model="value"
        />
      </b-col>
      <b-col md="6" lg="6" sm="12">
        <Select
          id="type"
          label="Tipo de movimentação:"
          labelBold
          v-model="type"
          :options="options"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" lg="6" sm="12">
        <Label for="imprimirComprovante" bold>Imprimir comprovante</Label>
        <checkbox-switch
          v-model="checkGeneratePrint"
          id="imprimirComprovante"
          style="margin: 0px !important"
        />
      </b-col>
    </b-row>
    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button type="success" @click="save()">Gravar</Button>
    </div>
  </Modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Modal } from '@/components';
import { Button, Select, CheckboxSwitch, Label } from '@/components/Form';
import Money from '../Form/InputMoney';

export default {
  name: 'ModalMovimentationCheckout',
  components: {
    Modal,
    Button,
    Money,
    Select,
    CheckboxSwitch,
    Label,
  },
  data() {
    return {
      value: 0,
      type: null,
      options: [
        { value: 'sangria', text: 'Sangria' },
        { value: 'suprimento', text: 'Suprimento' },
      ],
      quantity: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 2,
        masked: true,
      },
      checkGeneratePrint: false,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    setMovimentation: {
      type: Function,
      required: true,
    },
  },
  methods: {
    ...mapActions('pdv', ['setGeneratePrint']),
    save() {
      this.setGeneratePrint(this.checkGeneratePrint);
      this.setMovimentation(
        this.value,
        this.type,
        this.checkGeneratePrint ? this.checkGeneratePrint : 0,
      );
    },
  },
  watch: {
    open() {
      this.type = null;
      this.value = 0;
    },
    generatePrint(newValue) {
      this.checkGeneratePrint = newValue;
    },
  },
  computed: {
    ...mapState('pdv', ['generatePrint']),
  },
};
</script>

<style>
.text-center label {
  margin-bottom: 10px !important;
}
</style>
